export const MIN_UNIX_TIMESTAMP = 99999999;
export const MAX_UNIX_TIMESTAMP = 10000000000;

export function isValidTimestamp(value: unknown): boolean {
  const text = String(value);
  if (/\D/.test(text)) return false;
  const number = Number(text);
  return Number.isInteger(number) && number > MIN_UNIX_TIMESTAMP && number < MAX_UNIX_TIMESTAMP;
}

export function isUrl(value: string): boolean {
  return /^(http|https):\/\/[^\s]+$/.test(value);
}
